module.exports = __webpack_public_path__ + "images/399f3967.png";